module.exports = __webpack_public_path__ + "img/46.7.Chla.9008c7aa.png";